import { Link } from "@tanstack/react-router"
import { BrandMark } from "@/components/ui/brand-mark"

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/comics", label: "Comics" },
  { to: "/gallery", label: "Gallery" },
  { to: "/auteur", label: "Auteur" },
  { to: "/contact", label: "Contact" },
] as const

const YEAR = new Date().getFullYear()

export function Footer() {
  return (
    <footer className="relative z-30 border-white/[0.04] border-t bg-background/50 px-4 pt-10 pb-7 backdrop-blur-sm sm:px-8 sm:pt-12 sm:pb-8">
      <div className="mx-auto max-w-350">
        <div className="flex flex-col items-start justify-between gap-10 sm:flex-row sm:items-center sm:gap-6">
          <BrandMark className="h-auto px-0 text-white sm:px-0" />

          <nav
            aria-label="Footer"
            className="flex flex-wrap items-center gap-x-7 gap-y-3 font-medium font-mono text-[13px] text-white sm:gap-x-9 sm:text-sm"
          >
            {NAV_LINKS.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className="transition-colors duration-200 hover:text-brand"
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>

        <hr className="mt-10 border-white/10 sm:mt-12" />

        <div className="mt-5 flex flex-col items-start justify-between gap-3 font-sans text-[12px] text-white tracking-normal sm:mt-6 sm:flex-row sm:items-center sm:text-[13px]">
          <span className="inline-flex items-center gap-1.5">
            <img
              src="/copyright.svg"
              alt="©"
              width={14}
              height={14}
              className="h-3 w-3 brightness-0 invert sm:h-3.5 sm:w-3.5"
            />
            {YEAR} SHY Productions Ltd. All Rights Reserved.
          </span>
          <span className="inline-flex items-center gap-1.5">
            Developed By:
            <a
              href="https://qriousco.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 transition-colors hover:text-white"
            >
              <img
                src="/bird.webp"
                alt="Qriousco Tech"
                width={20}
                height={20}
                className="h-4 w-4 sm:h-5 sm:w-5"
                loading="lazy"
                decoding="async"
              />
              Qriousco Tech Pvt. Ltd.
            </a>
          </span>
        </div>
      </div>
    </footer>
  )
}
